import { Button, styled } from "@mui/material";
import { Colors } from '../../Styles/colors';

export const Title = styled('h2')`
  color:${Colors.primary.blue};
  text-align:center;
  font-size:50px;
  border-bottom: 2px solid ${Colors.primary.orange};
  margin-bottom: 10px;
`;

export const StyledButton = styled(Button)(({theme})=>({
  // width:'50%',
  flexGrow:1,
  // height: '100px',
  margin:'10px',
  alignSelf:'center',
  color:`white`,
  backgroundColor:`${Colors.primary.orange}`,
  fontSize:'30px',
  '&:hover': {
    backgroundColor: `${Colors.primary.blue}`,
  },
}));
